'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSignalWifiOff = function MdSignalWifiOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5.5 2.4q0.9 1 12 12t16.6 16.8l-2.1 2.1-5.5-5.6-6.5 8.1-19.4-24.2q2.6-2.1 6.1-3.6l-3.3-3.5z m33.9 9.2l-9.1 11.4-17.3-17.2q3.6-0.8 7-0.8 9.9 0 19.4 6.6z' })
        )
    );
};

exports.default = MdSignalWifiOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/signal-wifi-off.js
// module id = 3337
// module chunks = 0